import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { NotificationIcon } from 'common/images/FaIcons';
import { connect } from 'react-redux';
import { FlexContainer } from 'common/components/atoms';
import { bindActionCreators } from 'redux';
import * as activityActions from '../actions/activity.actions';

const StyledNotificationCount = styled.span`
  position: absolute;
  right: -4px;
  top: 0.5%;
  margin-top: 10px; 
  font-size: 70%; 
  padding: 0.4em; 
  border-radius: 999px;
  line-height: 0.75em; 
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 2em;
  font-weight: bold;
`;

function ActivityTabHeader({ activityUnreadActions, user, activityUnreadCount, machine_id }) {
  const { t } = useTranslation();

  useEffect(() => {
    const { getActivityUnreadCount } = activityUnreadActions;
    const { account_id } = user.user;

    const unreadCountParams = {
      account_id,
      machine_id
    };

    // Only read from localStorage for site-level view (no machine_id)
    // Machine-specific views should use default values
    if (!machine_id) {
      const activityFilterParams = JSON.parse(localStorage.getItem('activityListFilters'));
      const savedFilters = activityFilterParams ? activityFilterParams[account_id] : null;

      if (savedFilters) {
        const filters = [];

        if (savedFilters.state && savedFilters.state.length > 0) {
          filters.push(JSON.stringify({
            name: 'state',
            op: 'in',
            value: savedFilters.state
          }));
        }

        if (savedFilters.machines && savedFilters.machines.length > 0) {
          filters.push(JSON.stringify({
            name: 'machine_id',
            op: 'in',
            value: savedFilters.machines
          }));
        }

        if (savedFilters.analysis && savedFilters.analysis.length > 0) {
          filters.push(JSON.stringify({
            name: 'analysis',
            op: 'in',
            value: savedFilters.analysis.map(r => r === 'analysed')
          }));
        }

        if (savedFilters.suspension_status && savedFilters.suspension_status.length > 0) {
          filters.push(JSON.stringify({
            name: 'suspension',
            op: 'in',
            value: savedFilters.suspension_status.map(r => r === 'on')
          }));
        }

        if (savedFilters.read_status && savedFilters.read_status.length > 0) {
          filters.push(JSON.stringify({
            name: 'read_status',
            op: 'in',
            value: savedFilters.read_status.map(r => r === 'read')
          }));
        }

        if (savedFilters.type && savedFilters.type.length > 0) {
          unreadCountParams.type = savedFilters.type.map(type => type.toLowerCase());
        }

        if (savedFilters.days && savedFilters.days.value !== undefined) {
          unreadCountParams.days = savedFilters.days.value;
        }

        if (filters.length > 0) {
          unreadCountParams.filters = filters;
        }
      }
    }

    getActivityUnreadCount(unreadCountParams);
  }, []);

  return (
    <FlexContainer alignItems="center">
      {t('home.tabs.activity')}{' '}
      {activityUnreadCount > 0 && (
        <>
          <StyledNotificationCount>{activityUnreadCount}</StyledNotificationCount>
          <NotificationIcon style={{ marginLeft: '6px' }} />
        </>
      )}
    </FlexContainer>
  );
}

const mapStateToProps = state => ({
  activityUnreadCount: state.activityUnreadCount.unreadCount,
  user: state.user
});

const mapDispatchToProps = dispatch => ({
  activityUnreadActions: bindActionCreators(activityActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityTabHeader);
